import { cdn } from "constants/common";
import React from "react";
import { Table } from "reactstrap";
import { useTranslation } from "react-i18next";

const InterpreterTransLogsTable = ({ item }) => {
  const { t } = useTranslation();
  const phase = item?.translation_details?.current_phase;
  const totalQuantity = item?.translation_details?.total_quantity;

  const quantityColumnLabel = React.useMemo(() => {
    if (phase === "review") return t("translationView.totalPages");
    if (phase === "other" || phase === "transcription") return t("translationView.totalAudioMinutes");
    return t("translationView.totalWordsCount");
  }, [phase, t]);
  // const formattedDate = moment(timeZone).format('MMMM DD YYYY, hh:mm A');
  const renderTableHeader = React.useCallback(() => {
    return (
      <tr>
        <th className="col-2">{t("translationView.docName")}</th>
        {/* <th className="col-2">Total Words Count</th> */}
        <th className="col-2">{quantityColumnLabel}</th>
        {/* <th className="col-2">Estimated Words Count</th> */}
        {/* <th className="col-2">Total Estimated Amount</th> */}
      </tr>
    );
  }, [quantityColumnLabel]);

  const renderTableContent = React.useCallback((item) => {
    return <LogItem item={item} key={item?.id} phase={phase} totalQuantity={totalQuantity} />;
  }, [phase, totalQuantity]);

  return (
    <div className="table_responsive">
      <table className="table">
        <thead className="text-primary">{renderTableHeader()}</thead>
        <tbody>
          {item?.translation_files &&
            item?.translation_files?.map((item) => renderTableContent(item))}
        </tbody>
      </table>
    </div>
  );
};


const LogItem = ({ item, phase, totalQuantity }) => {
  const quantityValue = React.useMemo(() => {
      if (phase === "review") {
        return totalQuantity ?? item?.word_count ?? "N/A";
      }
      return item?.word_count ?? "N/A";
    }, [phase, totalQuantity, item?.word_count]);
  return (
    <tr>
      <td className="col-2">
        <a href={cdn + item?.original_file} target="_blank">{item?.original_file_name || "N/A"}</a>
      </td>
      {/* <td className="col-2">{item?.word_count ?? "N/A"}</td> */}
      <td className="col-2">{quantityValue}</td>
      {/* <td className="col-2">{item?.est_words_count ?? 0}</td> */}
            {/* <td className="col-2">$ {item?.amount ?? 0}</td> */}

      {/* <td className="col-2">{item?.total_amount ?? 0}</td> */}
    </tr>
  );
};
export default InterpreterTransLogsTable;
